import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React from "react";
import Airport from "@engineering/icons/airport";
import CityStation from "@engineering/icons/city-station";
import TrainStation from "@engineering/icons/train-station";
import { IconWrapper, Price } from "./LocationSuggest.styles";
var icons = {
    city: CityStation,
    citywithoutrail: CityStation,
    multiairports: Airport,
    multiairport_single: Airport,
    airport: Airport,
    multirail: TrainStation,
    rail_only: TrainStation,
    multirail_single: TrainStation
};
export var SearchResultItem = function(param) {
    var suggestion = param.suggestion;
    var Icon = icons[suggestion.type];
    var _title;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(IconWrapper, {
                "aria-hidden": "true",
                children: Icon && /*#__PURE__*/ _jsx(Icon, {
                    width: "24",
                    height: "24"
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                children: (_title = suggestion.title) !== null && _title !== void 0 ? _title : ""
            }),
            suggestion.minPrice && /*#__PURE__*/ _jsx(Price, {
                children: suggestion.minPrice
            })
        ]
    });
};
